// components/shared/sectors/SectorCard.tsx
import { CategoriesList } from "../categories/CategoriesList";
import { Sector } from "@cabukaka/types";
import { ShopsList } from "../shops/ShopsList";
import ShopsListBySector from "../shops/ShopsListBySector";


interface SectorCardProps {
  sector: Sector;
}

export function SectorCard({ sector }: SectorCardProps) {

  return (
    <div>
    

      <ShopsListBySector sector={sector} />

    </div>
  );
}